import React from 'react';
import { useCustomPageTitle } from '../hooks/usePageTitle';
import { QuickEstimate } from '../components/estimation/quick/QuickEstimate';

const QuickEstimatePage: React.FC = () => {
  useCustomPageTitle('Estimation rapide gratuite');
  return <QuickEstimate />;
};

export default QuickEstimatePage;
